<script setup>
import {ref, watch, onBeforeMount} from "vue";
import {getTagScenario} from "@/api/tag/tag.js";

onBeforeMount( async () => {
  if(props.isSecond) {
    await getScenario('init')
  }
})

// 父组件传值
const props = defineProps({
  // 左边展示内容
  unselected: {
    required: true,
    type: Array
  },
  // 右边展示内容
  selected: {
    required: true,
    type: Array
  },
  // 是否有二级分组（配合标签组应用功能使用）
  isSecond: {
    type: Boolean,
    default: false
  },
  // 禁用状态
  disabled: {
    type: Boolean,
    default: false
  }
})
// 事件
const emit = defineEmits(["toRight", "toLeft", "changeScenario"])

// 树形组件属性设置
const defaultProps = {
  children: 'pool',
  label: 'name',
  isLeaf: 'isTag',
  disabled: "disabled"
}
const rightProps = {
  children: 'pool',
  label: 'name',
  isLeaf: 'isTag',
  disabled: ""
}
// 加载状态
const loading = ref(false)

// 获取应用场景组
const getScenario = async (type = 'init') => {
  try {
    loading.value = true
    const res = await getTagScenario()
    options.value = res
    console.log("res", res)
    if (type === 'init') {
      scenario.value = res[0].key
    }
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 场景组选项
const options = ref([])
// 选中的场景组
const scenario = ref()

// 左边节点过滤关键字
const filterLeftText = ref('')
// 左边树节点锚点
const leftTreeRef = ref()
// 右边树节点锚点
const rightTreeRef = ref()
// 处理左边节点过滤关键字监听
watch(filterLeftText, (val) => {
  leftTreeRef.value.filter(val)
})
// 左边节点过滤方法
const filterLeftNode = (value, data) => {
  if (!value) return true
  console.log("data", data)
  return data.name.includes(value)
}
// 右边节点过滤关键字
const filterRightText = ref('')
// 右边树节点锚点
const rightTree = ref()
// 处理右边节点过滤关键字监听
watch(filterRightText, (val) => {
  rightTree.value.filter(val)
})
// 处理穿梭框左边选取到右边
const handleLeft2Right = () => {
  console.log("run in handleLeft2Right")
  const res = leftTreeRef.value.getCheckedNodes()
  let temp = []
  let tempGroup = []
  res.map(item => {
    if (!item.isTag) {
      tempGroup.push(item.id)
    } else {
      temp.push(item.id)
    }
  })
  let tempSource = []
  let tempGroupSource = []
  props.selected.map(item => {
    if (!item.isTag) {
      tempGroupSource.push(item.id)
    } else {
      tempSource.push(item.id)
    }
    if (props.isSecond && item.pool.length > 0) {
      item.pool.map(i => {
        tempSource.push(i.id)
      })
    }
  })
  emit("toRight", [...tempSource, ...temp], [...tempGroupSource, ...tempGroup])
}
// 处理穿梭框右边选取到左边
const handleRight2Left = () => {
  const res = rightTreeRef.value.getCheckedNodes()
  console.log("res", res)
  let temp = []
  let tempGroup = []
  res.map(item => {
    if (!item.isTag) {
      tempGroup.push(item.id)
    } else {
      temp.push(item.id)
    }
  })

  let tempSource = []
  let tempGroupSource = []
  props.selected.map(item => {
    if (!item.isTag) {
      tempGroupSource.push(item.id)
    } else {
      tempSource.push(item.id)
    }
    if (props.isSecond && item.pool.length > 0) {
      item.pool.map(i => {
        tempSource.push(i.id)
      })
    }
  })
  let set2 = new Set(temp)
  if (props.isSecond) {
    const result = tempSource.filter(item => !set2.has(item))
    let set3 = new Set(tempGroup)
    const resultGroup = tempGroupSource.filter(item => !set3.has(item))
    emit("toLeft", result, resultGroup)
  } else {
    const result = tempSource.filter(item => !set2.has(item))
    console.log("!isSecond", tempSource)
    emit("toLeft", result)
  }

}
// 处理应用场景改变
const handleScenarioChange = (item) => {
  console.log("item", item)
  emit("changeScenario", item)
}
</script>

<template>
  <div class="yt_transfer_box" v-loading="loading">
    <div class="yt_transfer_left">
      <el-input
          v-model="filterLeftText"
          class="w-60 mb-2"
          placeholder="搜索标签和标签分组"
      />
      <el-tree
          ref="leftTreeRef"
          style="max-width: 600px;border-radius: 12px;"
          :data="unselected"
          :props="defaultProps"
          :filter-node-method="filterLeftNode"
          show-checkbox
          default-expand-all
          check-strictly
          empty-text="暂无标签信息"
          check-on-click-node
      >
        <template #default="{ node, data }">
          <div class="custom-tree-node flex_center">
            <v-icon icon="mdi-folder-open-outline" class="mg_r_1" v-if="!data.isTag"></v-icon>
            <span>{{ node.label }}</span>
            <el-tag class="mg_l_1" v-if="node.disabled" type="info" size="small">禁用</el-tag>
          </div>
        </template>
      </el-tree>
    </div>
    <div class="yt_transfer_mid">
      <div class="mg_b_2">
        <v-btn color="#796cb4" :disabled="props.disabled" @click="handleLeft2Right">
          <template v-slot:default>
            <v-icon icon="mdi-chevron-right"></v-icon>
          </template>
        </v-btn>
      </div>
      <div>
        <v-btn color="#796cb4" :disabled="props.disabled" @click="handleRight2Left">
          <template v-slot:default>
            <v-icon icon="mdi-chevron-left"></v-icon>
          </template>
        </v-btn>
      </div>
    </div>
    <div class="yt_transfer_right">
      <div v-if="props.isSecond">
        <div class="ytCard_box flex_left">
          <div class="ytCard_title_box flex_left">
            <div class="ytCard_title_line"></div>
            <div class="ytCard_title" v-text="`应用场景组：`" ></div>
            <el-select v-model="scenario" placeholder="场景组" style="width: 240px" @change="handleScenarioChange">
              <el-option
                  v-for="item in options"
                  :key="item.key"
                  :label="item.description"
                  :value="item.key"
              />
            </el-select>
          </div>
        </div>
      </div>
      <div class="yt_transfer_right_count">已选标签：（{{selected.length}}）</div>
      <el-tree
          ref="rightTreeRef"
          style="max-width: 600px;border-radius: 12px;"
          :data="selected"
          :props="rightProps"
          show-checkbox
          default-expand-all
          empty-text="暂无标签信息"
          check-on-click-node
      >
        <template #default="{ node, data }">
          <div class="custom-tree-node flex_center">
            <v-icon icon="mdi-folder-open-outline" class="mg_r_1" v-if="!data.isTag"></v-icon>
            <span :class="data.disabled ? 'yt_transfer_disabled' : ''">{{ node.label }}</span>
            <el-tag class="mg_l_1" v-if="data.disabled" type="info" size="small">禁用</el-tag>
          </div>
        </template>
      </el-tree>
    </div>
  </div>
</template>

<style scoped>
.yt_transfer_box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .yt_transfer_mid {
    margin: 0 20px;
  }
  .yt_transfer_right,
  .yt_transfer_left {
    min-width: 350px;
    height: 550px;
    border: 1px solid #272539;
    border-radius: 12px;
    overflow: auto;
    box-sizing: border-box;
    padding: 10px;
  }
  .yt_transfer_right_count {
    text-align: left;
    font-size: 14px;
    margin-bottom: 20px;
  }
  .yt_transfer_disabled {
    color: #b0b1bd;
  }
}
.ytCard_box {
  width: 100%;
  text-align: left;
  padding-top: 10px;
  .ytCard_title_box {
    margin-bottom: 20px;
    box-sizing: border-box;
    .ytCard_title_line {
      width: 4px;
      height: 32px;
      background: #796CB4;
      border-radius: 2px;
      margin-right: 15px;
    }
    .ytCard_title {
      margin-right: 20px;
      font-weight: bold;
      font-size: 18px;
      color: #000000;
    }
  }
}
</style>
